import {ObjectDTO} from "./object-dto";

export class UniteDeProduction__SecteurDTO extends ObjectDTO {
  idSecteur: number;
  idUniteDeProduction: number;

}
